import { useMemo } from "react"
import useGet from '@hooks/useGet'
import { OptionsType } from "react-select"
import { resources } from "@api"

export default () => {
    const { data: awards, status } = useGet<Interfaces.Award[]>(resources.awards)

    const options: OptionsType<{ label: string; value: string; }> | undefined = useMemo(() => 
        awards?.map(award => ({ value: award.id.toString(), label: award.name })), [awards])

    return { awards, options, status }
}